import { AbstractControl } from '@angular/forms';

export function hasNumberValidator(control: AbstractControl): { [key: string]: any } | null {
    const hasNumber = /\d/.test(control.value);
    return hasNumber ? null : { numberRequired: true };
}
